import axios from "axios";

/**
 * Generate (or re-sign, if already generated) the full RE2020 RSET thermal study
 * PDF from the folder's XML document. The backend renders the entire document via
 * the official CSTB XSL, stores it on the folder (xml.etude_thermique_file), and
 * returns a fresh signed URL.
 *
 * @param {string} folderId
 * @param {string} fileId  GCS path of the uploaded XML (folder.xml.file.id)
 * @param {string} token   Firebase ID token
 * @param {string} prefix  API base URL
 * @param {boolean} [modifThermal]  Render the mise-à-jour XML (folder.modif_thermal.xml)
 *   instead of the original one; the PDF is cached on modif_thermal.xml.etude_thermique_file.
 * @returns {Promise<{success: boolean, file?: object, message?: string}>}
 */
const generateEtudeThermique = async (
  folderId,
  fileId,
  token,
  prefix,
  modifThermal = false
) => {
  try {
    const url = `${prefix}folders/${folderId}/xml/generate_etude_thermique`;
    const response = await axios.post(
      url,
      { file_id: fileId, modif_thermal: modifThermal },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { success: true, file: response.data?.file };
  } catch (error) {
    const message =
      error?.response?.data?.detail ||
      error?.message ||
      "Impossible de générer l'étude thermique.";
    console.error("generateEtudeThermique error:", message);
    return { success: false, message };
  }
};

export default generateEtudeThermique;
